import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import HomePage from './Views/Home';
import AboutPage from './Views/About';
import Packages from './Views/Packages';
import PackageDetails from './Views/Packages/packageDetails';
import NewsPage from './Views/News/index';
import Services from './Views/Services/index';
import Quote from './Views/Contact/Contact';
import Hiring from './Views/Hire';
import Faq from './Views/Faq';
import Newsdetail from './Views/News/NewsDetail';
import  Feedback  from './Views/feedback';
import Phonemenu from './Components/Phonemenuss';
// import { routes } from "./routes";
import { LayoutOne, LayoutThree, LayoutTwo} from "./Components/layout";
import Verticals from "./Views/Verticals";
import Career from "./Views/career";
import Product from "./Views/product";
import Productdetail from "./Views/product/productdetail";
import Technologies from "./Views/technologies";
import Parthership from "./Views/parthership";
import TermsConditions from "./Components/Terms&Conditions";
import PrivacyPolicy from "./Components/privacyPolicy";

function App() {
    return (
        <div>
            <Router>
                <Switch>
					<RouteWrapper path="/" exact component={() => <HomePage />} layout={LayoutOne} />
					<RouteWrapper path="/about-us" exact component={() => <AboutPage />} layout={LayoutOne} />
					<RouteWrapper path="/packages" exact component={() => <Packages />} layout={LayoutOne} />
					<RouteWrapper path="/packageDetails" exact component={() => <PackageDetails />} layout={LayoutOne} />
					<RouteWrapper path="/news" exact component={() => <NewsPage />} layout={LayoutOne} />
                    <RouteWrapper path="/news/:slug" exact component={() => <NewsPage />} layout={LayoutOne} />
					<RouteWrapper path="/contact" exact component={() => <Quote />} layout={LayoutOne} />
					<RouteWrapper path="/service" exact component={() => <Services />} layout={LayoutOne} />
					<RouteWrapper path="/hire" exact component={() => <Hiring />} layout={LayoutOne} />
					<RouteWrapper path="/career" exact component={() => <Career />} layout={LayoutOne} />
					<RouteWrapper path="/faq" exact component={() => <Faq />} layout={LayoutOne} />
					<RouteWrapper path="/newsdetail/:slug" exact component={() => <Newsdetail />} layout={LayoutOne} />
					<RouteWrapper path="/feedback" exact component={() => <Feedback />} layout={LayoutOne} />
					<RouteWrapper path="/phonemenu" exact component={() => <Phonemenu />} layout={LayoutTwo} />
					<RouteWrapper path="/verticals" exact component={() => <Verticals />} layout={LayoutOne} />
                    <RouteWrapper path="/product" exact component={() => <Product />} layout={LayoutOne} />
                    <RouteWrapper path="/productdetail/:slug" exact component={() => <Productdetail />} layout={LayoutOne} />
                    <RouteWrapper path="/technologies" exact component={() => <Technologies />} layout={LayoutOne} />
                    <RouteWrapper path="/parthership" exact component={() => <Parthership />} layout={LayoutOne} />
                    <RouteWrapper path="/faq" exact component={() => <Faq />} layout={LayoutOne} />
                    <RouteWrapper path="/terms-conditions" exact component={() => <TermsConditions />} layout={LayoutOne} />
                    <RouteWrapper path="/privacy-policy" exact component={() => <PrivacyPolicy />} layout={LayoutOne} />
                </Switch>
            </Router>
        </div>
    );
}

function RouteWrapper({
    component: Component,
    layout: Layout,
    ...rest
}) {
    return (
        <Route {...rest} render={(props) =>
            <Layout {...props}>
                <Component {...props} />
            </Layout>
        } />
    );
}

export default App;

